import React, { useCallback } from 'react';
import {
  Box,
  IconButton,
  Text,
  MenuItem,
  Menu,
  MenuButton,
  MenuList,
  Portal,
  MenuGroup,
  useDisclosure,
  DotsSolidIcon,
  RulerIcon,
  ShareIcon,
} from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { isBeatHoveredSelector } from '../../../beats/beats.selector';
import { ClusterBeat } from '../../clustering.types';
import { useHolterClusterUrl } from '../../hooks/useHolterClusterUrl';
import { initializeRuler } from '../../../ruler/thunks/initialize-ruler.thunk';
import { setActiveTool } from '../../../tool/actions/tool.actions';
import { Tool } from '../../../tool/utils/tool.utils';
import { BeatModal } from '../basic/BeatModal';

interface Props {
  beat: ClusterBeat;
}

export const BeatMoreAction: React.FC<Props> = ({ beat }) => {
  const dispatch = useDispatch();
  const hovered = useSelector(isBeatHoveredSelector(beat.id));
  const url = useHolterClusterUrl(beat.onset);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const activateRuler = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onOpen();
      dispatch(initializeRuler());
      dispatch(
        setActiveTool({
          tool: Tool.ruler,
          meta: { history: false },
        }),
      );
    },
    [dispatch, onOpen],
  );
  return (
    <>
      <BeatModal beat={beat} onClose={onClose} modalOpen={isOpen} />
      <Box height='2rem'>
        <Box
          display='flex'
          justifyContent='center'
          visibility={hovered ? 'visible' : 'hidden'}
        >
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton as='span' onClick={(e) => e.stopPropagation()}>
                  <IconButton
                    pointerEvents='auto'
                    variant='tertiary'
                    size='sm'
                    aria-label='actions'
                    icon={<DotsSolidIcon />}
                    isActive={isOpen}
                  />
                </MenuButton>
                <Portal>
                  <MenuList>
                    <MenuGroup title='Actions'>
                      <MenuItem as='a' href={url} target='_blank'>
                        <ShareIcon mr='s' />
                        <Text>View Parent Holter</Text>
                      </MenuItem>
                      <MenuItem onClick={activateRuler}>
                        <RulerIcon mr='s' />
                        <Text>Measure</Text>
                      </MenuItem>
                    </MenuGroup>
                  </MenuList>
                </Portal>
              </>
            )}
          </Menu>
        </Box>
      </Box>
    </>
  );
};
